import React from 'react';
import { withRouter } from 'react-router';
import { IonButton, IonIcon } from '@ionic/react';
import { forwardTo } from '../../lib/utils';
import backArrow from '../../assets/images/back-arrow.svg'

const BackButton = (props) => {
	const { history, path, style, className, backHandler, iconColor } = props;
	return (
		<IonButton
			className={`${className ? className : null} menu-back`}
			button
			clear
			onClick={() => (backHandler ? backHandler() : path ? forwardTo(path) : history.goBack())}
			style={style ? { ...style } : {}}
		>
			<IonIcon size='24'  slot="icon-only" icon={backArrow} />
		</IonButton>
	);
};

export default withRouter(BackButton);
